import MarkdownIt from 'markdown-it';
import DOMPurify from 'dompurify';
const markdown = new MarkdownIt({ html: false, breaks: true, linkify: false });
export const renderText = text => DOMPurify.sanitize(markdown.render(text || ''));
export const states = {
  draft: 'Черновик', pinned: 'Закреплён', unpinned: 'Закреп снят', attention: 'Требует проверки',
  queued: 'В очереди', attempting: 'Выполняется', unknown: 'Проверьте Telegram', succeeded: 'Выполнено', failed: 'Ошибка', skipped: 'Пропущено', cancelled: 'Отменено',
};
export const actions = { publish: 'Перепубликация', update: 'Обновление', unpin: 'Снятие закрепа', delete: 'Удаление' };
export const errors = {
  invalid_text: 'Введите текст поста.', text_limit: 'Текст слишком длинный: с баннером — до 1024, без него — до 4096 символов.',
  invalid_banner: 'Выберите изображение JPG или PNG размером до 10 МБ.',
  invalid_button: 'Введите название кнопки: до 64 символов.', invalid_url: 'Укажите полную ссылку http:// или https://.',
  invalid_groups: 'Выберите доступные группы.', revision_conflict: 'Данные изменились. Обновите список и заново откройте пост перед сохранением.',
  busy: 'По одной из выбранных групп уже выполняется операция. Дождитесь результата или проверьте Telegram.',
  past_schedule: 'Выбранное время уже прошло в одной из групп. Укажите будущую дату и время.',
  invalid_schedule: 'Проверьте дату, время и дни повторения.', timezone_required: 'У группы не определён часовой пояс. Планирование недоступно.',
  group_unavailable: 'Группа пока недоступна для публикации ботом.', no_current_post: 'В одной из групп ещё нет опубликованного поста.',
  no_current_pin: 'В одной из групп закреп уже снят.', republish_required: 'Чтобы убрать баннер, перепубликуйте пост: Telegram не позволяет убрать фото из существующего сообщения.',
  bot_rights_missing: 'Боту не хватает прав администратора на закрепление или удаление.',
  telegram_unconfirmed: 'Telegram не подтвердил результат. Автоматического повтора нет. Проверьте группу.',
  interrupted: 'Операция прервалась. Проверьте результат в Telegram.', overdue_skipped: 'Время прошло во время простоя. Пост не отправлялся.',
  configuration_changed: 'Подключение группы или бота изменилось. Проверьте настройки.',
  rate_limited: 'Telegram ограничил частоту запросов. Повтор выполняется с задержкой.',
  execution_disabled: 'Публикация временно недоступна.',
};
export function errorText(error) {
  if (error?.response?.status === 403) return 'Недостаточно прав. Раздел доступен администратору.';
  return errors[error?.response?.data?.error] || 'Не удалось подтвердить действие. Обновите список перед повтором.';
}
export function localTime(value, timezone) {
  if (!value || !timezone) return '—';
  return new Intl.DateTimeFormat('ru-RU', { timeZone: timezone, dateStyle: 'short', timeStyle: 'short' }).format(new Date(value));
}
